import { useState, useEffect, useMemo } from "react"
import { useTenant } from "../../../hooks/useTenant"
import { EnrollmentService } from "../../../services/enrollment"

/**
 * useClassMembers
 * Busca os membros matriculados em uma turma usando o EnrollmentService do NeoApp.
 * Enriquece os dados com informações completas do cache central de membros.
 */
export const useClassMembers = ({ classId, withLoading, allMembers = [] }) => {
    const { idTenant } = useTenant()
    const [enrolledMembers, setEnrolledMembers] = useState([])

    useEffect(() => {
        setEnrolledMembers([]) // Clear immediately to prevent old data flash
        
        if (!classId) {
            return
        }

        const fetchMembers = async () => {
            try {
                const enrolled = await EnrollmentService.getEnrolledMembersByClass(idTenant, classId)
                setEnrolledMembers(enrolled || [])
            } catch (error) {
                console.error("Erro ao buscar alunos da turma:", error)
                setEnrolledMembers([])
            }
        }

        if (withLoading) {
            withLoading('classMembers', fetchMembers)
        } else {
            fetchMembers()
        }
    }, [classId, idTenant, withLoading])

    const members = useMemo(() => {
        return (enrolledMembers || []).map(e => {
            const memberInfo = allMembers.find(m => m.id === e.id) || {}

            return {
                id: e.id,
                idMember: e.id,
                name: memberInfo.fullName || e.fullName || "Aluno",
                photo: memberInfo.photoUrl || null,
                memberNumber: memberInfo.memberNumber || "",
                status: memberInfo.status || "active",
                email: memberInfo.email || "",
                phone: memberInfo.phone || memberInfo.cellPhone || "",
                cellPhone: memberInfo.cellPhone || "",
                responsavelPhone: memberInfo.responsavelPhone || "",
            }
        }).filter(m => m.status === 'active' || m.status === 'suspended')
    }, [enrolledMembers, allMembers])

    return { members }
}
